// extracted by mini-css-extract-plugin
export default {"placementStationTable":"BqkcQxYEBErEoZfN1kJm","tableContainer":"VVGy9mE5il_cF9eePtGb"};